import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card card-body tw-ml-5 tw-mt-2" }
const _hoisted_2 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PAYMENT FOR HOUR"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "HOURS FOR DAY"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DAYS FOR WEEK"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WEEKS FOR MONTHS"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MONTHS FOR YEAR")
  ])
], -1)
const _hoisted_4 = { class: "data" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center b-0" }, " $ ", -1)
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "tw-flex tw-justify-around tw-items-center tw-mt-5" }
const _hoisted_13 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " MONTHLY INCOME $: ", -1)
const _hoisted_15 = { class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3 d-flex align-items-center justify-contetn-center" }
const _hoisted_16 = { class: "tw-flex tw-items-center tw-gap-2 tw-ml-2" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]

import { toRefs, watch } from 'vue';
import { currencyFormat } from '@/composables/filters';


export default /*#__PURE__*/_defineComponent({
  __name: 'IncomeHourly',
  props: {
  hourlyIncome: {
    type: Array,
    default: []
  }
},
  setup(__props) {

const props = __props;


const { hourlyIncome }: any = toRefs(props)

// Watch the entire array for changes
watch(hourlyIncome, (newItems) => {
  newItems.forEach((item, index) => {
    // Calculate monthly income for each item
    if (item.paymentForHour > 0 && item.hoursForWeek > 0 &&
      item.daysForWeek > 0 && item.weeksForMonth > 0) {

      const dailyIncome = item.paymentForHour * item.hoursForWeek;
      const weeklyIncome = dailyIncome * item.daysForWeek;
      const monthlyIncome = (((item.weeksForMonth + 0.33) * 12) * weeklyIncome) / 12;
      const yearlyIncome = (item.monthsForYear * monthlyIncome) / 12;

      // Update the monthlyIncome in the array
      hourlyIncome.value[index].monthlyIncome = yearlyIncome || 0;
    }
  });
}, { deep: true });

const removeIncomeType = (index) => {
  hourlyIncome.value.splice(index, 1)
}

const addIncomeType = () => {
  hourlyIncome.value.push({
    paymentForHour: 0,
    hoursForWeek: 0,
    daysForWeek: 0,
    weeksForMonth: 0,
    monthsForYear: 0,
    monthlyIncome: 0,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hourlyIncome), (hour, index) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "w-full b-0",
                    placeholder: "0.00",
                    min: "0",
                    "onUpdate:modelValue": ($event: any) => ((hour.paymentForHour) = $event)
                  }, null, 8, _hoisted_7), [
                    [_vModelText, hour.paymentForHour]
                  ])
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((hour.hoursForWeek) = $event)
                }, null, 8, _hoisted_8), [
                  [_vModelText, hour.hoursForWeek]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((hour.daysForWeek) = $event)
                }, null, 8, _hoisted_9), [
                  [_vModelText, hour.daysForWeek]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((hour.weeksForMonth) = $event)
                }, null, 8, _hoisted_10), [
                  [_vModelText, hour.weeksForMonth]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((hour.monthsForYear) = $event)
                }, null, 8, _hoisted_11), [
                  [_vModelText, hour.monthsForYear]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(currencyFormat)(hour.monthlyIncome)), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            (index > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-danger tw-bg-[#da0000] tw-text-white",
                  onClick: ($event: any) => (removeIncomeType(index))
                }, _hoisted_19, 8, _hoisted_17))
              : _createCommentVNode("", true),
            (_unref(hourlyIncome).length == index + 1 && index != 2)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-primary tw-bg-[#00a0da] tw-text-white",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (addIncomeType()))
                }, _hoisted_21))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    }), 256))
  ]))
}
}

})